var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state === 'loading')?_c('loading',{staticClass:"mx-auto"}):(_vm.state === 'empty')?_c('div',{staticClass:"mx-auto"},[_c(_vm.component,{tag:"component"})],1):_c('div',{staticClass:"w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }